import React from 'react';
import Field from '@/components/Field/Field';
import { Box } from '@chakra-ui/react';
import { IQualificationModule, IQualification } from 'api-paths-cas';
import { getFormattedQualificationModuleString } from '../helpers/formatting';
import { getAllUniqueQualificationModuleIds } from '../helpers/findUniqueIds';

export interface IModulesProps {
  qualificationCurrent?: IQualification;
  qualificationInitial?: IQualification;
}

export function QualificationModules(props: IModulesProps): React.ReactElement {
  const { qualificationCurrent, qualificationInitial } = props;
  let modulesCurrent = qualificationCurrent?.modules || [];
  let modulesInitial = qualificationInitial?.modules || [];

  if (!Array.isArray(modulesCurrent)) modulesCurrent = [];
  if (!Array.isArray(modulesInitial)) modulesInitial = [];

  const ModuleComponents: React.ReactElement[] = [];

  const ids = getAllUniqueQualificationModuleIds(
    modulesCurrent as IQualificationModule[],
    modulesInitial as IQualificationModule[],
  );

  // Build maps by composite key to support array shapes
  const map1 = new Map<string, IQualificationModule>();
  const map2 = new Map<string, IQualificationModule>();

  for (const m of modulesCurrent || []) {
    if (!m) continue;
    map1.set(`${m.subject}-${m.grade}`, m);
  }
  for (const m of modulesInitial || []) {
    if (!m) continue;
    map2.set(`${m.subject}-${m.grade}`, m);
  }

  for (const [index, id] of ids.entries()) {
    const module1: IQualificationModule | undefined = map1.get(id);
    const module2: IQualificationModule | undefined = map2.get(id);

    ModuleComponents.push(<Module key={`${id}-${index}`} id={id} moduleCurrent={module1} moduleInitial={module2} />);
  }

  return <>{ModuleComponents}</>;
}

export interface IModuleProps {
  id: string;
  moduleCurrent?: IQualificationModule;
  moduleInitial?: IQualificationModule;
}

export function Module(props: IModuleProps): React.ReactElement {
  const { id, moduleCurrent, moduleInitial } = props;

  const string1 = getFormattedQualificationModuleString(moduleCurrent);
  const string2 = getFormattedQualificationModuleString(moduleInitial);

  return (
    <Box ml={2} mb={1} key={id}>
      <Field leftLabel={'Module'} value={string1} originalValue={string2} />
    </Box>
  );
}
